import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=9c534c0e&scoped=true&"
import script from "./SideMenu.vue?vue&type=script&lang=js&"
export * from "./SideMenu.vue?vue&type=script&lang=js&"
import style0 from "./SideMenu.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SideMenu.vue?vue&type=style&index=1&id=9c534c0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c534c0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c534c0e')) {
      api.createRecord('9c534c0e', component.options)
    } else {
      api.reload('9c534c0e', component.options)
    }
    module.hot.accept("./SideMenu.vue?vue&type=template&id=9c534c0e&scoped=true&", function () {
      api.rerender('9c534c0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/slxc/components/SideMenu.vue"
export default component.exports